import * as types from "../types/zone.types";

const initialState = {
  zoneData: [],
  storeData: [],
  dashboardData: [],
  dashboardFilter: {
    // storeIds: [],
    currentPage: "",
    limit: "",
    // keyword: "",
    // startDate: "",
    // endDate: "",
  },
  zoneViewdata: [],
};

const ZoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ZONE_DATA:
      return { ...state, zoneData: action.payload };
    case types.SET_STORE_DATA:
      return { ...state, storeData: action.payload };
    case types.SET_DASHBOARD_DATA:
      return { ...state, dashboardData: action.payload };
    case types.SET_DASHBOARD_DATA_FILTER:
      return { ...state, dashboardFilter: action.payload };
    case types.SET_ZONE_VIEW_DATA:
      return { ...state, zoneViewdata: action.payload };
    case types.RESET_ZONE_REDUCER:
      return { 
        ...state, 
        zoneData: [],
        storeData: [],
        dashboardData: [],
        dashboardDataPagination: [],
        zoneViewdata: [],
      };
    default:
      return state;
  }
};
export default ZoneReducer;
